export const socialMediaLinks = [
  {
    name: 'YouTube',
    url: 'https://www.youtube.com/@welikethedoodles',
    icon: 'youtube2',
  },
  {
    name: 'Instagram',
    url: 'https://www.instagram.com/thedoodles',
    icon: 'instagram',
  },
  {
    name: 'TikTok',
    url: 'https://www.tiktok.com/@doodles',
    icon: 'tiktok',
  },
  {
    name: 'Twitter',
    url: 'https://twitter.com/doodles',
    icon: 'x-twitter2',
  },
];
